<div class="main-font modal-container">
  <div class="modal-header">
    <p class="mb-0 title-header">
      Sei sicuro di voler eliminare la {{ text }}?
    </p>
    <p class="mb-0 title-description">
      Questa operazione non potrà essere annullata
    </p>
  </div>
  <div class="modal-body">
    <div class="user-container">
      <img
        [src]="utilityService.getSanitizeUrl(user.path)"
        [alt]="user.first_name"
        class="user-image" />
      <div class="user-info">
        <p class="mb-0 user-name">{{ user.first_name }} {{ user.last_name }}</p>
        <p class="mb-0 user-role">{{ user.role }}</p>
      </div>
    </div>
    <div class="date-info">
      <img
        src="assets/images/icon_calendar/calendar.svg"
        alt="calendar"
        class="icon-calendar" />
      <p
        class="mb-0 date-info-text"
        *ngIf="
          request.type != 'Malattia' && request.type != 'Ferie';
          else other
        ">
        {{ capitalizeFirst(startDate | date: 'EEE d/MM/YYYY HH:mm') }} -
        {{ endDate | date: 'HH:mm' }}
      </p>
      <ng-template #other>
        {{ capitalizeFirst(startDate | date: 'EEE d/MM/YYYY') }} -
        {{ capitalizeFirst(endDate | date: 'EEE d/MM/YYYY') }}
      </ng-template>
    </div>
    <div class="d-flex align-items-center gap-3 w-100">
      <button class="primary-btn-outline-new w-100" (click)="closeModal()">
        Chiudi
      </button>
      <button class="secondary-btn-new w-100" (click)="confirmDelete()">
        Elimina
      </button>
    </div>
  </div>
</div>
